module.exports = __webpack_public_path__ + "img/design.f7e1434f.svg";